import * as __rspack_external__apollo_client_6d28652a from "@apollo/client";
const defaultOptions = {};
const CompassWebSecurityGetCentralizedOrgIdDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "CompassWebSecurityGetCentralizedOrgId"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "security"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "current_session"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "centralized_session"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "centralized_organization_id"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
function useCompassWebSecurityGetCentralizedOrgIdQuery(baseOptions) {
    const options = {
        ...defaultOptions,
        ...baseOptions
    };
    return __rspack_external__apollo_client_6d28652a.useQuery(CompassWebSecurityGetCentralizedOrgIdDocument, options);
}
function useCompassWebSecurityGetCentralizedOrgIdLazyQuery(baseOptions) {
    const options = {
        ...defaultOptions,
        ...baseOptions
    };
    return __rspack_external__apollo_client_6d28652a.useLazyQuery(CompassWebSecurityGetCentralizedOrgIdDocument, options);
}
export { CompassWebSecurityGetCentralizedOrgIdDocument, useCompassWebSecurityGetCentralizedOrgIdLazyQuery, useCompassWebSecurityGetCentralizedOrgIdQuery };
